import { useMatch, useNavigate } from "react-router-dom";
import { CatalogDialog } from "@/components/catalog/CatalogDialog";

// Route-driven catalog controller. Mounted once in the Layout so the catalog
// dialog is the single, consistent selection-and-order experience.
//   /produk        -> open catalog (no preselect)
//   /produk/:slug  -> open catalog with that platform preselected
export function CatalogController() {
  const navigate = useNavigate();
  const matchList = useMatch("/produk");
  const matchSlug = useMatch("/produk/:slug");
  const open = Boolean(matchList || matchSlug);
  const initialSlug = matchSlug?.params?.slug;

  return (
    <CatalogDialog
      open={open}
      initialSlug={initialSlug}
      onSelectSlug={(slug) =>
        navigate(slug ? `/produk/${slug}` : "/produk", { replace: true })
      }
      onClose={() => navigate("/")}
    />
  );
}
